import { useFeatureAvailable, useSoftDeployAccess } from 'App/components/hooks';
import { Feature } from 'Store/actions/FeatureHelperActions';

export default function useListActivitiesAllowed() {
	const hasReactList = useSoftDeployAccess('REACT_ACTIVITIES_LIST');
	const hasFeature = useFeatureAvailable(Feature.ACTIVITIES_AND_APPOINTMENTS);
	return hasReactList && hasFeature;
}
